export enum RequirementRiskWeight {
	Critical = 1,
	HighRisk = 2,
	MediumRisk = 3,
	LowRisk = 4,
}
